var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 42,
    viewBox: "0 0 52 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59388 5.42587C7.97378 4.98688 8.52568 4.73462 9.10623 4.73462H33.6681C34.7727 4.73462 35.6681 5.63005 35.6681 6.73462V11.9413C35.6681 13.0458 34.7727 13.9413 33.6681 13.9413H4.60051C2.88735 13.9413 1.96712 11.928 3.08817 10.6325L7.59388 5.42587Z",
    fill: "url(#paint0_linear_2700_5469)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3482 13.9421H45.5463",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80191 13.4052H0",
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.032 36.6932C10.9861 37.934 10.3705 40.4706 8.27573 40.6908C6.18093 40.9111 3.8197 40.7826 2.90094 40.6908V20.0183L10.0673 5.2725C10.7104 3.84834 12.7133 1 15.5798 1C18.4464 1 29.8206 1 35.1495 1C36.5276 1.22968 39.6422 2.40574 41.0755 5.2725C42.5087 8.13927 46.4502 16.2976 48.2418 20.0183V40.6908C46.197 41.0467 41.9942 41.3906 41.5415 39.9192C41.0888 38.4478 41.0699 37.1555 41.117 36.6932",
    stroke: "black",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3158 31.8092C41.9675 32.4572 33.7579 33.5566 25.4182 33.5566C15.2151 33.5566 9.94331 33.7525 7.87854 31.8092",
    stroke: "black",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5378 26.657C36.1779 24.6448 36.9701 20.7604 43.0186 21.3195",
    stroke: "black",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8463 26.657C14.2063 24.6448 13.4141 20.7604 7.36556 21.3195",
    stroke: "black",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8249 26.9153L34.4053 22.1987H17.0198L18.3834 26.9153H32.8249Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2700_5469",
    x1: 19.5399,
    y1: 4.73462,
    x2: 19.5399,
    y2: 13.9413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSmall);
export default __webpack_public_path__ + "static/media/carSmall.478bbd9aefc960f709e39a2515628534.svg";
export { ForwardRef as ReactComponent };